@if (securityContextPreserved()) {
    <p class="box box-danger" i18n>
        This report contains sources with disabled security context.
        In this report run the security context is preserved to prevent potential sensitive data leaks.
    </p>
}
@for (item of reportDisplay; track $index) {
    <div style="margin-bottom: 20px;">
        @if (isTableDisplayItem(item)) {
            <risr-features-reports-report-table [reportDisplayItem]="item"></risr-features-reports-report-table>
        }
        @if (isSeriesChartDisplayItem(item)) {
            <risr-features-reports-report-series-chart [reportDisplayItem]="item"></risr-features-reports-report-series-chart>
        }
        @if (isXYChartDisplayItem(item)) {
            <risr-features-reports-report-xy-chart [reportDisplayItem]="item"></risr-features-reports-report-xy-chart>
        }
        @if (isTextDisplayItem(item)) {
            <div class="text-container">
                <p>{{ item.content }}</p>
            </div>
        }
        @if (isAISummaryDisplayItem(item)) {
            <risr-features-reports-report-ai-summary [reportDisplayItem]="item"></risr-features-reports-report-ai-summary>
        }
        @if (!$last) {
            <hr>
        }
    </div>
} @empty {
    <p i18n>No output defined</p>
}